import http from '@/helpers/Http';
import extension from './extension';
import ringGroups from './ringGroups';
import dids from './dids';
import ivr from './ivr';

export default {
    namespaced: true,
    state: {
        tenants: [],
    },
    getters: {
        tenants: state => state.tenants,
    },
    mutations: {
        setTenants(state, tenants) {
            state.tenants = tenants;
        },
    },
    actions: {
        async getTenants({ commit }) {
            const response = await http.get('pbxware/tenants');

            commit('setTenants', response.data);

            return response;
        }
    },
    modules: {
        extension,
        ringGroups,
        dids,
        ivr,
    }
}